import React from 'react'
import TittleBanner from '../shared/TittleBanner'
import Navbar from '../shared/Navbar'
import DescBanner from '../shared/DescBanner'
import Footer from '../Footer/footer' 
import img1 from '../assets/images/Projekt_1/P_2402_01.jpg'
import img2 from '../assets/images/Projekt_1/P_2402_02.jpg'
import img3 from '../assets/images/Projekt_1/P_2402_03.jpg'
import img4 from '../assets/images/Projekt_1/P_2402_04.jpg'
import img5 from '../assets/images/Projekt_8/Scene 1.1.png'
import img6 from '../assets/images/Projekt_8/Scene 3.1.png'
import img7 from '../assets/images/Projekt_8/Scene 5.1.png'
import img8 from '../assets/images/Projekt_8/Scene 11.1.png'
import CarouselModule from '../shared/Carousel'

const data = [
  {img: img1,},
  {img: img2,},
  {img: img3,},
  {img: img4,},
  {img: img5,},
  {img: img6,},
  {img: img7,},
  {img: img8,},
]

export default function Interior() {
  return (
    <div>
      <Navbar/>
      <TittleBanner img="bg-about-us-banner" tiitle="Interior"/>
      <DescBanner text="At Arcium Studio, we believe interior design is about more than just aesthetics—it’s about creating spaces that feel personal, functional, and inspiring. Our interior service transforms empty rooms into environments that reflect your style and enhance your everyday living.
      We work closely with you to understand your taste, needs, and lifestyle, then craft bespoke interiors that balance beauty and practicality. From selecting color palettes, materials, and finishes to planning lighting, furniture, and space layout, we focus on every detail to create harmonious and lasting designs.
      Whether it’s a cozy home, a modern apartment, or a dynamic commercial space, our goal is to shape interiors that are not only visually stunning but also comfortable and efficient.
      Let’s turn your space into something truly exceptional." />

      <CarouselModule data={data} tittle="Interior Projects"/>
      <Footer/>
    </div>
  )
}
